import { z } from "zod";
import { default as dayjs } from "dayjs";

export const EneryaListingPageFormSchema = z.object({
    startDate: z.any().optional(),
    endDate: z.any().optional(),
});

export type EneryaListingPageValuesType = z.infer<typeof EneryaListingPageFormSchema>;

export const EneryaListingPageInitialValues: EneryaListingPageValuesType = {
    startDate: dayjs().startOf('month'),
    endDate: dayjs(),
};  
